import ForecastDay from './ForecastDay';
import { useTranslation } from 'react-i18next';


const NextDays = (props) => {
    
    const { t } = useTranslation();
    return (
    
    <div id="forcast_days">
        <h3>{t("FORECAST_TITLE")} - {t("FORECAST_4D")}</h3>
        
        <ul className="forecast_header">
        <li className=" forcast_day">
            
           
        </li>
        <li className=" forcast_text">
            
           
        </li>
        <li class="forecast_strip_container"><ul class="forecast_strip">
         <li className="forcast_morning ">
            {t("MORNING")}
           
        </li>
        <li className="forcast_noon ">
             {t("NOON")}
            
            
        </li>
        <li className="forcast_night  ">
            {t("NIGHT")}
            
            
        </li>
        </ul>
        </li>
        
        <li className=" more">
            
           
        </li>
        </ul>
        {props.days.map((day, i) => {
             return <ForecastDay key={i} a_key={i} className="white_box" {...day} lang={props.lang} yest={props.yest} activities_json={props.activities_json}></ForecastDay>;
          })}
    </div>
    );
}

export default NextDays; 